"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _context = _interopRequireDefault(require("./context"));

var useStagedFonts = function useStagedFonts() {
  var _useContext = (0, _react.useContext)(_context.default),
      stage = _useContext.stage;

  return (0, _react.useMemo)(function () {
    return {
      isCriticalStage: stage === 0,
      stage: stage
    };
  }, [stage]);
};

var _default = useStagedFonts;
exports.default = _default;